// extracted by mini-css-extract-plugin
export default {"lookForward":"scsl3"};